// extracted by mini-css-extract-plugin
export default {"container_div":"styles_container_div__QnLUA","commentsCard":"styles_commentsCard__GvWDm","commentsText":"styles_commentsText__2EK6b"};